import React from "react";
import Slide from "../../utils/images/bridesmaid-main-1920-a.jpg";
import { HeartFilled } from "@ant-design/icons";
import { HeartStyle } from "../data/data";
import styled from "styled-components";
const Layout = styled.div`
  font-family: "Oswald" sans-serif;
`;
function Banner() {
  return (
    <>
      <Layout>
        <div style={styles.banner}>
          <h3 style={styles.title}>MAID OF HONOR</h3>
          <p>
            <HeartStyle>
              <span className="white-line"></span>
              <HeartFilled style={{ fontSize: 19, zIndex: 20, color: "red" }} />
              <HeartFilled
                style={{
                  fontSize: 19,
                  marginLeft: -5,
                  color: "white",
                }}
              />
              <span className="white-line"></span>
            </HeartStyle>
          </p>
          <span style={styles.text}>
            Lorem ipsum dolor adipiscing elit. Integer <br /> ultrices malesuada
            ante quis pharetra. Nullam <br /> non bibendum dolor. Ut vel turpis
            accumsan, efficitur
          </span>
        </div>
      </Layout>
    </>
  );
}
const styles = {
  banner: {
    background: `linear-gradient(0deg,rgba(215,210,210,0.5),rgba(200,170,210,0.5)),url(${Slide})`,
    height: 470,
    backgroundSize: "cover",
    padding: 40,
    backgroundPosition: "center",
    color: "white",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "center",
    textAlign: "center",
    fontWeight: "bold",
  },
  text: {
    fontSize: 16,
    fontWeight: 500,
    fontfamily: " 'Big Shoulders Display', cursive",
    // transform: "rotate(-10deg)",
    marginBottom: 24,
    // width: "50%",
    color: "white",
    fontFamily: "sans-serif ",
    textAlign: "center",
  },
  title: {
    letterSpacing: 3,
    fontSize: 35,
    fontWeight: 700,
    color: "white",
    marginBottom: 24,
    fontFamily: "sans-serif ",
    textAlign: "center",
  },
};

export default Banner;
